import { render, staticRenderFns } from "./Manage-AssetCategory.vue?vue&type=template&id=741798d5"
import script from "./Manage-AssetCategory.vue?vue&type=script&lang=js"
export * from "./Manage-AssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports